var _rect, _path, _rect2, _rect3, _ellipse;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProductHeadset(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 160 120",
    fill: "none",
    role: "img",
    "aria-label": "Wireless headset",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 160,
    height: 120,
    rx: 10,
    fill: "#EEF2F8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42 72c0-20 17-36 38-36s38 16 38 36",
    stroke: "#002454",
    strokeWidth: 7,
    strokeLinecap: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 70,
    width: 18,
    height: 30,
    rx: 7,
    fill: "#9e00ff"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 112,
    y: 70,
    width: 18,
    height: 30,
    rx: 7,
    fill: "#9e00ff"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 80,
    cy: 38,
    rx: 14,
    ry: 10,
    fill: "#002454",
    opacity: 0.15
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductHeadset);
export default __webpack_public_path__ + "static/media/product-headset.30d23ddf3c0e6892c007fa57f24d8936.svg";
export { ForwardRef as ReactComponent };